import React from "react";
import { accountingApi } from "../../services/accountingApi";

const money = (n) =>
    `S/ ${Number(n || 0).toLocaleString("es-PE", { minimumFractionDigits: 2 })}`;
const parseDetails = (raw) => {
    if (!raw) return [];
    if (Array.isArray(raw)) return raw;
    try {
        return JSON.parse(raw) || [];
    } catch {
        return [];
    }
};

const buildRequester = (movement) => {
    const external = String(movement.requester_external || "").trim();
    const internal = String(movement.requester_user || "").replace(/\s+/g, " ").trim();

    if (external) {
        return { type: "Externo", name: external };
    }

    if (internal) {
        return { type: "Interno", name: internal };
    }

    return { type: "", name: "-" };
};

export default function MovementsTable({ rows, reload, permissions }) {
    const canDelete = permissions?.canDelete === true;

    const cancel = async (id) => {
        if (!canDelete) return alert("El rol 8 no puede anular movimientos.");
        if (!window.confirm("¿Seguro que deseas anular este movimiento?")) return;
        await accountingApi.cancelMovement(id);
        await reload();
    };

    return (
        <section className="accCard tableWrap">
            <table className="accTable">
                <thead>
                    <tr>
                        <th>Fecha</th>
                        <th>Tipo</th>
                        <th>RUC</th>
                        <th>Sede / Ciudad</th>
                        <th>Celular</th>
                        <th>Banco</th>
                        <th>Proveedor</th>
                        <th>Solicitante</th>
                        <th>Pagos</th>
                        <th>Detalle</th>
                        <th>Efectivo</th>
                        <th>Online</th>
                        <th>Total</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((x) => {
                        const details = parseDetails(x.payment_details);
                        const requester = buildRequester(x);
                        return (
                            <tr key={x.id}>
                                <td>
                                    {x.created_at
                                        ? new Date(x.created_at).toLocaleString("es-PE", {
                                            year: "numeric",
                                            month: "2-digit",
                                            day: "2-digit",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            second: "2-digit",
                                            hour12: false,
                                        })
                                        : "-"}
                                </td>{" "}
                                <td>
                                    <span
                                        className={`pill ${x.movement_type === "TRANSFER" ? "TRANSFER" : x.operation_type}`}
                                    >
                                        {x.movement_type === "TRANSFER"
                                            ? "TRANSFER"
                                            : x.operation_type}
                                    </span>
                                </td>
                                <td>{x.business_name || "-"}</td>
                                <td>
                                    {x.sd_sede || "-"}
                                    <br />
                                    <small>{x.movement_city || "-"}</small>
                                </td>
                                <td>{x.movement_phone || "-"}</td>
                                <td>
                                    {x.movement_type === "TRANSFER"
                                        ? `${x.origin_bank_name || "-"} → ${x.destination_bank_name || "-"}`
                                        : x.bank_name || "-"}
                                </td>
                                <td>{x.supplier_name || "-"}</td>
                                <td>
                                    <div className="requesterMini">
                                        <b>{requester.name}</b>
                                        {requester.type && <small>{requester.type}</small>}
                                    </div>
                                </td>
                                <td>
                                    {details.length
                                        ? details.map((p, i) => (
                                            <div className="payMini" key={i}>
                                                <b>
                                                    {p.payment_method ||
                                                        (p.ruc_bank_id ? "Online" : "Efectivo")}
                                                </b>{" "}
                                                {money(p.amount)}
                                                {p.bank_label && <small>{p.bank_label}</small>}
                                                {p.reference && <small>Ref: {p.reference}</small>}
                                            </div>
                                        ))
                                        : "-"}
                                </td>
                                <td>{x.detail || "-"}</td>
                                <td className="amount">{money(x.cash_amount)}</td>
                                <td className="amount">{money(x.online_amount)}</td>
                                <td className="amount">{money(x.amount)}</td>
                                <td>
                                    {canDelete && (
                                        <button type="button" onClick={() => cancel(x.id)}>
                                            Anular
                                        </button>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </section>
    );
}
